// extracted by mini-css-extract-plugin
module.exports = {"tikitDroppable":"_1YRyounlmpdcYxqTy4JAG5","tikitDroppableBrowser":"sGmP7DtAmZ7wldg951iOH"};